export default function breakpoints(configs, width) {
  // default to the first (smallest) size
  let match = configs[0];

  // from narrowest to widest, find the first
  // minWidth definition that is greater than
  // the current width of the page (simulating)
  // media queries
  for (const config of configs) {
    const { minWidth = 0 } = config;
    if (!minWidth) continue;
    if (width >= minWidth && minWidth > match.minWidth) {
      match = config;
    }
  }

  return match;
};